export const FOCUS_QUEUE_CHANGED_EVENT = 'vizionops:focus-queue-changed';

export function emitFocusQueueChanged(detail = {}) {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(FOCUS_QUEUE_CHANGED_EVENT, {
    detail: {
      action: detail.action || 'refresh',
      item: detail.item || null
    }
  }));
}

export function subscribeToFocusQueueChanges(handler) {
  if (typeof window === 'undefined' || typeof handler !== 'function') {
    return () => {};
  }
  window.addEventListener(FOCUS_QUEUE_CHANGED_EVENT, handler);
  return () => window.removeEventListener(FOCUS_QUEUE_CHANGED_EVENT, handler);
}

export function applyFocusQueueCountDelta(counts, item, direction = -1) {
  if (!counts || !item?.itemKey) return counts;
  const delta = direction < 0 ? -1 : 1;
  const nextByType = { ...(counts.byType || {}) };
  if (item.type) {
    nextByType[item.type] = Math.max(0, Number(nextByType[item.type] || 0) + delta);
  }
  return {
    ...counts,
    total: Math.max(0, Number(counts.total || 0) + delta),
    overdue: item.isOverdue
      ? Math.max(0, Number(counts.overdue || 0) + delta)
      : Number(counts.overdue || 0),
    byType: nextByType
  };
}
